import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';

export const ErrorP = styled(Typography)(({ theme }) => {
  return { color: theme.palette.error.main };
});

export const SuccessP = styled(Typography)(({theme}) => {
  return {color: theme.palette.success.main}
})
